import { GlobalResponseObject } from '@gtpl/shared-models/common-models';
import {HsnDto} from './hsn.dto'

export class AllHsnResponseModel extends GlobalResponseObject{
    data?: HsnDto[];
    /**
     * 
     * @param status 
     * @param errorCode 
     * @param internalMessage 
     * @param data //ProductDto
     */
    constructor(status: boolean, errorCode: number, internalMessage: string, data?: HsnDto[]) {
        super(status, errorCode, internalMessage);
        this.data = data;
    }
}